module.exports = __webpack_public_path__ + "img/c623693.jpg";